import React, { useEffect, useState } from "react";
import "./QuickLinksCard.scss";

//imports for user data
import { useSelector } from "react-redux";

const QuickLinksCard = ({
  setMarginTop,
  title,
  Icon,
  setShowPay,
  openModal,
  closeModal,
  setFieldToShow,
}) => {
  //data fetched from the store
  const { user, profile } = useSelector((state) => state.landlordslice);

  const rent = profile?.tenant_details?.unpaidInvoices?.rent;
  const water = profile?.tenant_details?.unpaidInvoices?.water;
  const arrears = profile?.tenant_details?.unpaidInvoices?.arrears;
  const serviceCharge = profile?.tenant_details?.unpaidInvoices?.serviceFee;
  const unpaidDeposit = profile?.tenant_details?.unpaidInvoices?.unpaidDeposit;
  const garbage = profile?.tenant_details?.unpaidInvoices?.garbage;

  function shortenNumber(value) {
    const num = parseInt(value, 10);

    if (isNaN(num)) return value; // Return original value if it's not a valid number

    if (num >= 1_000_000) {
      return (num / 1_000_000).toFixed(1) + "M"; // Format for millions
    } else if (num >= 1_000) {
      return (num / 1_000).toFixed(1) + "k"; // Format for thousands
    } else {
      return num.toString(); // Return the number as is if it's less than 1000
    }
  }

  // Check if the screen width is smaller than 768px and setMarginTop is true
  const marginTop = setMarginTop && window.innerWidth < 768 ? "10px" : "0px";

  return (
    <button
      style={{ padding: "0px", backgroundColor: "transparent", border: "none" }}
      onClick={() => {
        if (setShowPay) {
          //switchcase to check the title and set the fields to show
          switch (title) {
            case "Rent":
              setFieldToShow(["rent"]);
              break;
            case "Water":
              setFieldToShow(["water"]);
              break;
            case "Arrears":
              setFieldToShow(["arrears"]);
              break;
            case "Service Charge":
              setFieldToShow(["serviceCharge"]);
              break;
            case "Unpaid Deposit":
              setFieldToShow(["unpaidDeposit"]);
              break;
            case "Garbage":
              setFieldToShow(["garbage"]);
              break;
            default:
              console.log("Invalid title");
          }
          setShowPay(true);
        }
      }}
    >
      <div className="my-container" style={{ marginTop }}>
        <div className="card-wrapper">
          <div
            className="card"
            onClick={() => {
              if (openModal) {
                // switch case to check the title and set the fields to show
                switch (title) {
                  case "Rent":
                    openModal(["rent"]);
                    break;
                  case "Water":
                    openModal(["water"]);
                    break;
                  case "Arrears":
                    openModal(["arrears"]);
                    break;
                  case "Service Charge":
                    openModal(["serviceCharge"]);
                    break;
                  case "Unpaid Deposit":
                    openModal(["unpaidDeposit"]);
                    break;
                  case "Garbage":
                    openModal(["garbage"]);
                    break;
                  default:
                    console.log("Invalid title");
                }
              }
            }}
          >
            <div className="card-front">
              <div className="icon-circle">{Icon && <Icon size={20} />}</div>
              <div className="card-content">
                <p className="card-title">{title}</p>
              </div>
            </div>
            <div className="card-back">
              <div className="icon-circle">
                <div style={{ fontSize: "16px" }}>
                  {/* switch case to display value according to title */}
                  {title === "Rent" && shortenNumber(rent)}
                  {title === "Water" && shortenNumber(water)}
                  {title === "Arrears" && shortenNumber(arrears)}
                  {title === "Service Charge" && shortenNumber(serviceCharge)}
                  {title === "Unpaid Deposit" && shortenNumber(unpaidDeposit)}
                  {title === "Garbage" && shortenNumber(garbage)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </button>
  );
};

export default QuickLinksCard;
